export default __webpack_public_path__ + "static/media/ic_attachment_file.95c72623.svg";